export default [
  {
    path: "/",
    name: "Academico",
    component: () => import("../../view/Academico.vue"),
    meta: {
      titulo: "Acadêmico",
      breadcrumb: [
        { text: "Acadêmico", disabled: true, to: "/" },
      ],
    },
  },
  {
    path: "/Encargos",
    name: "Encargos",
    component: () => import("../../view/Encargos.vue"),
    meta: {
      titulo: "Encargos",
      breadcrumb: [
        { text: "Acadêmico", disabled: false, to: "/" },
        { text: "Encargos", disabled: true },
      ],
    },
  },

  {
    path: "/Encargos/ConfirmacaoAdministrativo",
    name: "Confirmacao-Administrativo",
    component: () => import("../../view/ConfirmacaoAdministrativo.vue"),
    meta: {
      titulo: "Administrativo",
      breadcrumb: [
        { text: "Acadêmico", disabled: false, to: "/" },
        { text: "Encargos", disabled: false, to: "/Encargos" },
        { text: "Confirmacao-Administrativo", disabled: true },
      ],
    },
  },
  {
    path: "/Encargos/ConfirmacaoDocente",
    name: "Confirmacao-Docente",
    component: () => import("../../view/ConfirmacaoDocente.vue"),
    meta: {
      titulo: "Docente",
      breadcrumb: [
        { text: "Acadêmico", disabled: false, to: "/" },
        { text: "Encargos", disabled: false, to: "/Encargos" },
        { text: "Confirmacao-Docente", disabled: true },
      ],
    },
  },
]
